import _ from 'lodash';
import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from '../lib/create_model';
import InteractionType from 'models/interaction_type';
import LiveboardType from 'models/liveboards/liveboard_type';
import { PreferencesStatus } from '../agent_routing_preferences';

export const ActiveSession = createModel({
  modelName: 'ActiveSession',
  properties: {
    conversationId: String,
    customerId: String,
    startedAt: String,
    fulfilledAt: String,
    sessionTypes: [String],
    slaDueAt: String,
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export const WorkType = createEnum('ACT', 'HANDLE', 'UNKNOWN');

export const SessionWork = createModel({
  modelName: 'SessionWork',
  properties: {
    customerId: String,
    sessionType: prop().oneOf(..._.values(InteractionType)),
    workType: prop().oneOf(..._.values(WorkType)),
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export const RoutingPreferences = createModel({
  modelName: 'RoutingPreferences',
  properties: {
    status: prop().oneOf(..._.values(PreferencesStatus)),
    updatedAt: String,
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export const UtilizationStats = createModel({
  modelName: 'UtilizationStats',
  properties: {
    activeSessions: [ActiveSession],
    activity: String,
    agentId: String,
    availableChannels: [String],
    onCall: Boolean,
    presenceUpdatedAt: String,
    routingPreferences: RoutingPreferences,
    sessionWork: SessionWork,
    status: String,
    statusReasonId: String,
    statusUpdatedAt: String,
    statusVersion: Number,
  },
  incrementStatusVersion() {
    this.statusVersion = this.statusVersion + 1;
  },
  setStatus(status) {
    this.status = status;
  },
  setStatusReasonId(statusReasonId) {
    this.statusReasonId = statusReasonId;
  },
  setStatusUpdatedAt(statusUpdatedAt) {
    this.statusUpdatedAt = statusUpdatedAt;
  },
  setStatusVersion(statusVersion) {
    this.statusVersion = statusVersion;
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default createModel({
  modelName: 'AgentsLiveboard',
  properties: {
    utilization: [UtilizationStats],
    timezone: prop(String).default('America/New_York'),
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: LiveboardType.AGENTS });
  },
});
